import {Component, inject, DOCUMENT, computed} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ThemeService} from '@/app/core/services/theme.service';
import {SettingsService} from '@/app/features/settings/services/settings.service';
import {layoutStore} from '@/app/layout/store/layout.store';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {Toast} from 'primeng/toast';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {LoaderComponent} from '@/app/core/components/loader/loader';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Toast,
    ConfirmDialog,
    LoaderComponent,
    TranslateModule,
  ],
  templateUrl: './app.html',
  standalone: true,
})
export class App {
  protected title = 'Muwarid';
  protected readonly toastPosition = computed<'top-right' | 'top-left'>(() =>
    layoutStore.isRtl() ? 'top-left' : 'top-right',
  );

  constructor() {
    const theme = inject(ThemeService);
    const mode = theme.init();
    layoutStore.setTheme(mode);

    const settings = inject(SettingsService);
    settings.init();

    const translate = inject(TranslateService);
    const lang = layoutStore.language();
    translate.use(lang);

    const doc = inject(DOCUMENT);
    const html = doc.querySelector('html');
    if (html) {
      html.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
      html.setAttribute('lang', lang);
    }
  }
}
